import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const BuyIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "currentColor",
    width: size || '40',
    height: size || '40'
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,37.8378378 C29.8515658,37.8378378 37.8378378,29.8515658 37.8378378,20 C37.8378378,10.1484342 29.8515658,2.16216216 20,2.16216216 C10.1484342,2.16216216 2.16216216,10.1484342 2.16216216,20 C2.16216216,29.8515658 10.1484342,37.8378378 20,37.8378378 Z M20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 Z M20.6393375,26.3293693 C22.735635,25.9219219 23.7837838,24.2825225 23.7837838,22.6882883 C23.7837838,21.0056457 22.8758936,20.0927327 20.8838424,19.1721321 L20.0271277,18.7752553 C18.9259081,18.2621021 18.2795813,17.8594595 18.2795813,17.132973 C18.2795813,16.4775976 18.7515326,15.975976 19.6603704,15.975976 C20.6393375,15.975976 21.4249753,16.4237838 21.9319911,16.9378979 L23.4530388,15.0178979 C23.3118325,14.8218619 22.5261948,13.7455856 20.8487777,13.4611411 L20.9009008,10.8108108 L18.7695387,10.8108108 L18.8387204,13.4630631 C17.0219924,13.7993994 15.6241449,15.458979 15.6241449,17.3722523 C15.6241449,18.7896697 16.3756656,19.8909309 18.1923936,20.7058258 L19.24149,21.1891892 C20.5862667,21.8099699 21.1454057,22.1213214 21.1454057,22.8295495 C21.1454057,23.4676276 20.656396,23.949069 19.6603704,23.949069 C18.2445167,23.949069 17.1091802,23.1754955 16.5851058,22.6796396 L15.1351351,24.7466666 C15.6241449,25.1896697 16.7073583,26.2217417 18.6122217,26.4177778 L18.5600985,29.0690691 L20.6914606,29.0690691 L20.6393375,26.3293693 Z",
    id: "path-buy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "buy-button",
    stroke: "none",
    fill: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Awesome-Icons---slider-+-grid",
    transform: "translate(-768 -936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/40Buy",
    transform: "translate(768 936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buy-color",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-buy"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-buy"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fillRule: "nonzero",
    xlinkHref: "#path-buy"
  }))))));
};
BuyIcon.displayName = 'BuyIcon';
export default BuyIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=BuyIcon.js.map